import { isArray, isDefined, isDev, SmartQueue } from "../utils/index.js";
import { features } from "./features.js";
let queue;
function addToQueue(fn) {
  if (!features.get("asyncChildren")) {
    fn();
    return;
  }
  if (!queue) {
    queue = new SmartQueue();
  }
  queue.add(fn);
}
const selectors = /* @__PURE__ */ new Map();
const separator = " ";
function getSelector(nameOrSelector) {
  if (!selectors.has(nameOrSelector)) {
    const parts = [
      // Single selector
      `[data-component="${nameOrSelector}"]`,
      // Selector in the middle of a list of selectors
      `[data-component*="${separator}${nameOrSelector}${separator}"]`,
      // Selector at the end of a list of selectors
      `[data-component$="${separator}${nameOrSelector}"]`,
      // Selector at the beginning of a list of selectors
      `[data-component^="${nameOrSelector}${separator}"]`
    ];
    selectors.set(nameOrSelector, parts.join(","));
  }
  return selectors.get(nameOrSelector);
}
function getComponentElements(nameOrSelector, element = document) {
  const selector = getSelector(nameOrSelector);
  let elements = [];
  try {
    elements = Array.from(element.querySelectorAll(selector));
  } catch {
  }
  if (elements.length === 0) {
    elements = Array.from(element.querySelectorAll(nameOrSelector));
  }
  return elements;
}
function eventIsDefinedInConfig(event, config) {
  return isArray(config.emits) && config.emits.includes(event);
}
function eventIsNative(event, element) {
  return isDefined(element[`on${event}`]);
}
function getEventTarget(instance, event, config) {
  if (eventIsDefinedInConfig(event, config)) {
    return instance;
  }
  if (eventIsNative(event, instance.$el)) {
    return instance.$el;
  }
  if (isDev) {
    console.warn(
      `[${config.name}]`,
      `The "${event}" event is missing from the configuration and is not a native`,
      `event for the root element of type \`${instance.$el.constructor.name}\`.`
    );
  }
  return instance;
}
export {
  addToQueue,
  eventIsDefinedInConfig,
  eventIsNative,
  getComponentElements,
  getEventTarget
};
//# sourceMappingURL=utils.js.map
